import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported'
import { Box, CardMedia, CardMediaProps } from '@mui/material'

export interface HotelImageProps extends CardMediaProps {
  alt?: string
  isRelative?: boolean
  contain?: boolean
}

export const CardImage = ({ contain, alt, image, sx, ...props }: HotelImageProps) => {
  if (!image) {
    return (
      <Box
        title="No Image"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 4,
          bgcolor: (theme) => theme.palette.grey[300],
        }}>
        <ImageNotSupportedIcon color="disabled" sx={{ fontSize: '10rem' }} />
      </Box>
    )
  }

  return (
    <CardMedia
      {...props}
      component="div"
      title={alt}
      sx={{
        // 16:9
        pt: '56.25%',
        backgroundSize: contain ? 'contain' : 'cover',
        ...sx,
      }}
      image={image}
    />
  )
}
